import { render } from "./InstanceQuickConnections.vue?vue&type=template&id=c6975c56&scoped=true"
import script from "./InstanceQuickConnections.vue?vue&type=script&lang=js"
export * from "./InstanceQuickConnections.vue?vue&type=script&lang=js"

import "./InstanceQuickConnections.vue?vue&type=style&index=0&id=c6975c56&lang=scss&scoped=true"

import exportComponent from "/home/forge/deployments/control-center.conneqt.io/new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6975c56"]])

export default __exports__